(function(angular) {
    'use strict';
    angular.module('wtUi.services').factory('changeViewMode', changeViewMode);

    changeViewMode.$inject = ['$rootScope', '$timeout', '$window'];

    function changeViewMode($rootScope, $timeout, $window) {
        function toggleFullscreen() {
            const docElm = document.documentElement;
            const isFullscreen = document.fullscreenElement || document.mozFullScreen
                || document.webkitIsFullScreen || document.msFullscreenElement;

            // checks if in fullscreen
            if (!isFullscreen) {
                // request fullscreen for different browsers
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen();
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen();
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen();
                } else if (docElm.msRequestFullscreen) {
                    docElm.msRequestFullscreen();
                }
            // cancel fullscreen for different browsers
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
        function toggleWideMode() {
            // Timeout for css transition end :/
            // The transition is scheduled for 300ms (.is-in-wide-mode)
            $timeout(() => {
                $rootScope.$emit('wtCommon:toggleWideMode:transitionEnd');
                // Inform the interested parties about the window resize
                $window.dispatchEvent(new Event('resize'));
            }, 2 * 200);
            $rootScope.$broadcast('wtCommon:toggleWideMode');
        }

        return {
            toggleFullscreen: toggleFullscreen,
            toggleWideMode: toggleWideMode
        };
    }
})(window.angular);

